import React from "react";
import { InlineRichTextEdit } from "../../../CommonUI/InlineEditor/InlineRichTextEdit";
import { IDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { PropertyEditorText } from "../../../CommonUI/PropertyEditing/PropertyEditorText";
import { StyledFormHelperText } from "./CommonStyled";
import { IssueData } from "../../Utilities/ControlRenderContext";
import { TextEntryFormControl } from "../TextEntryFormControl";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";
import { PropertyEditorBoolean } from "../../../CommonUI/PropertyEditing/PropertyEditorBoolean";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";
import { UISpacedBoxContent } from "../../../CommonUI/BuildlingBlocks/UISpacedBoxContent";
import { UILabel } from "../../../CommonUI/BuildlingBlocks/UILabel";

export class InlineRichTextEditorFormControl extends TextEntryFormControl {
    readonly __type: string = "Inline Rich Text Edit";
    showToolsOnFocus: boolean = false;
    exportFileName: string = "output";

    render() {
        const issueData: IssueData | null = this.getFormContext()!.getControlContext(this)!.getRuntimeIssueData();
        const issueText: string = issueData?.text || "";

        return (
            <div
                style={{
                    width: this.fullWidth ? "100%" : `${this.width || 200}px`,
                }}
            >
                {this.label && <UILabel variant={"form_label"}>{this.label}</UILabel>}
                <InlineRichTextEdit
                    value={this.valueName && this.getFormDataValue(this.valueName)}
                    updateCallback={(val) => this.valueName && val !== "" && this.setFormDataValue(this.valueName, val)}
                    placeholder={this.placeholderText || "Label"}
                    showToolsOnFocus={this.showToolsOnFocus}
                />
                {(issueText || this.hintText) && (
                    <StyledFormHelperText
                        error={Boolean(issueText)}
                        data-testid="issueOrHintText"
                    >
                        {issueText ? issueText : this.hintText}
                    </StyledFormHelperText>
                )}
            </div>
        );
    }

    getAddedData(): IDataDefinition | IDataDefinition[] | undefined {
        if (!this.valueName) return;

        let dd = new StringDataDefinition();
        dd.name = this.valueName;
        return dd;
    }

    renderEditUI(): JSX.Element | null {
        return <XInlineRichTextEditorUI editMe={this} />;
    }

    getStorageData(): object {
        let retData = super.getStorageData();

        retData = DataUtilities.addStorageData(this, retData, "__type", "showToolsOnFocus", "exportFileName");

        return retData;
    }

    setStorageData(data: object): void {
        super.setStorageData(data);

        DataUtilities.setStorageData(this, data, "__type", "showToolsOnFocus", "exportFileName");
    }
}

function XInlineRichTextEditorUI(props: { editMe: InlineRichTextEditorFormControl }) {
    return (
        <UISpacedBoxContent>
            {props.editMe.renderBaseDataControlEditor(["requiredOnAllOutcomes"])}
            <PropertyEditorBoolean
                editObject={props.editMe}
                label={"Show Tools On Focus"}
                propertyName={"showToolsOnFocus"}
            />
            {props.editMe.renderTextControlBasePropertyEditor()}
            <PropertyEditorText
                editObject={props.editMe}
                label={"Export File Name"}
                propertyName={"exportFileName"}
            />
        </UISpacedBoxContent>
    );
}
